/* assets/ms-pdp.js — MSBUILD ms-pdp-js 2026-09-08-a
   Generic. No Liquid. Operates on every [data-ms-pdp] root on the page.
   ES5 syntax only; see the build doc §5.7 for the baseline rationale. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-ms-pdp]');
  if (!roots.length) { return; }

  /* ---------- shared helpers ------------------------------------------- */
  function cartUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root : '/';
    if (r.charAt(r.length - 1) !== '/') { r += '/'; }
    return r + 'cart/add.js';
  }

  function post(items) {
    return fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (j) { throw j; }, function () { throw { status: r.status }; });
      }
      return r.json();
    });
  }

  function openDrawer() {
    if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); return; }
    try { document.dispatchEvent(new CustomEvent('mse:open-cart-drawer')); } catch (e) {}
  }

  /* ---------- per-root init -------------------------------------------- */
  function init(root) {
    root.classList.add('ms-js');

    var sid       = (root.id || '').replace('mspdp-', '');
    var form      = document.getElementById('mspdp-form-' + sid);
    var accs      = root.querySelectorAll('.ms-acc-in');
    var totalEl   = root.querySelector('[data-mspdp-total]');
    var noticeEl  = root.querySelector('[data-mspdp-notice]');
    var inlineCta = root.querySelector('form .ms-cta');
    var stickyCta = root.querySelector('[data-mspdp-sticky-cta]');
    var sticky    = root.querySelector('[data-mspdp-sticky]');
    var HERO_PRICE = parseInt(root.getAttribute('data-hero-price'), 10) || 0;
    var HERO_MONEY = root.getAttribute('data-hero-price-money') || '';
    var i;

    /* ----- qty stepper ------------------------------------------------- */
    var qty = root.querySelector('.ms-qty');
    if (qty) {
      qty.addEventListener('click', function (e) {
        var b = e.target;
        while (b && b !== qty && b.tagName !== 'BUTTON') { b = b.parentNode; }
        if (!b || b.tagName !== 'BUTTON') { return; }
        var input = qty.querySelector('input');
        if (!input) { return; }
        var n = parseInt(input.value, 10);
        if (isNaN(n)) { n = 1; }
        n += parseInt(b.getAttribute('data-step'), 10) || 0;
        if (n < 1) { n = 1; }
        input.value = n;
      });
    }

    /* ----- running total above the button ------------------------------ */
    function ticked() {
      var out = [], k;
      for (k = 0; k < accs.length; k++) { if (accs[k].checked) { out.push(accs[k]); } }
      return out;
    }

    function renderTotal() {
      if (!totalEl) { return; }
      var t = ticked();
      if (!t.length) { totalEl.textContent = ''; return; }
      var sum = HERO_PRICE, k;
      for (k = 0; k < t.length; k++) {
        sum += parseInt(t[k].getAttribute('data-price'), 10) || 0;
      }
      /* Sum the ADD-ONS only (not the hero) — that is the number the shopper is
         deciding about. Formatted with Intl using the currency Shopify reports;
         if that is unavailable we fall back to a count and say no number at all,
         because a wrong price on a page is worse than no price. */
      var extra = sum - HERO_PRICE;
      var money = null;
      try {
        var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
        if (cur) {
          money = new Intl.NumberFormat(undefined, {
            style: 'currency', currency: cur,
            minimumFractionDigits: (extra % 100 === 0) ? 0 : 2
          }).format(extra / 100);
        }
      } catch (e) { money = null; }
      totalEl.textContent = '+ ' + t.length + ' selected'
                          + (money ? ' · ' + money : '')
                          + ' — added with this product';
    }

    for (i = 0; i < accs.length; i++) { accs[i].addEventListener('change', renderTotal); }
    renderTotal();

    /* ----- add to cart -------------------------------------------------- */
    function busy(on) {
      var btns = root.querySelectorAll('.ms-cta'), k;
      for (k = 0; k < btns.length; k++) {
        if (on) {
          btns[k].setAttribute('aria-busy', 'true');
          btns[k].classList.add('is-busy');
        } else {
          btns[k].removeAttribute('aria-busy');
          btns[k].classList.remove('is-busy');
        }
      }
    }

    function warn(msg) {
      if (noticeEl) { noticeEl.textContent = msg; noticeEl.hidden = false; return; }
      if (typeof window.showCartToast === 'function') { window.showCartToast(msg); }
    }

    function flashDone() {
      var btns = root.querySelectorAll('.ms-cta'), k;
      for (k = 0; k < btns.length; k++) { btns[k].classList.add('is-done'); }
      window.setTimeout(function () {
        var b2 = root.querySelectorAll('.ms-cta'), j;
        for (j = 0; j < b2.length; j++) { b2[j].classList.remove('is-done'); }
      }, 1400);
    }

    var MIN_BUSY = 220;   /* below this a spinner reads as a glitch, not feedback */

    /* goCheckout=true is the BUY NOW path. It deliberately reuses this one
       function rather than Shopify's native payment_button: the dynamic
       checkout button buys the hero variant ONLY, so a shopper who ticked
       NanoBeatz and pressed Buy now would arrive at checkout without it.
       Same cart post, then straight to checkout. */
    function submitCart(goCheckout) {
      if (!form) { return; }
      var idEl  = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (!idEl || !idEl.value) { return; }

      var q = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (isNaN(q) || q < 1) { q = 1; }

      var hero  = { id: idEl.value, quantity: q };
      var extra = ticked();
      var items = [hero], k;
      /* Accessory lines are ALWAYS quantity 1. The stepper feeds the hero only.
         A per-accessory stepper turns an impulse tick into a configuration task. */
      for (k = 0; k < extra.length; k++) {
        items.push({ id: extra[k].getAttribute('data-variant-id'), quantity: 1 });
      }

      var t0 = Date.now();
      busy(true);
      if (noticeEl) { noticeEl.hidden = true; }

      /* PERF 2026-09-05 — the drawer used to open only inside .then(), and
         /cart/add.js costs 1.4–2.6s of Shopify server time on this store, so a
         plain add was seconds of dead air with nothing on screen.
         For the ordinary single-item add we open the drawer on the TAP and hand
         the line to the cart drawer's own window.addToCart, which paints an
         optimistic pending row immediately and reconciles it against the server
         when the POST lands (removing the row if it fails).
         Deliberately NOT used when accessories are ticked — that batch must stay
         a single request — nor on Buy now, which navigates away and would only
         flash a drawer. Both of those keep the original behaviour exactly. */
      if (!goCheckout && items.length === 1 && typeof window.addToCart === 'function') {
        openDrawer();
        var h1 = root.querySelector('h1');
        window.addToCart(hero.id, q, h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '', HERO_PRICE)
          .then(function () {
            var w = Math.max(0, MIN_BUSY - (Date.now() - t0));
            window.setTimeout(function () { busy(false); flashDone(); }, w);
          })['catch'](function (err) {
            busy(false);
            warn((err && err.description) ? err.description : 'Sorry, that is unavailable right now.');
          });
        return;
      }

      post(items).then(function () {
        if (goCheckout) { window.location.href = checkoutUrl(); return; }
        var wait = Math.max(0, MIN_BUSY - (Date.now() - t0));
        window.setTimeout(function () { busy(false); flashDone(); openDrawer(); }, wait);
      })['catch'](function (err) {
        /* NEVER lose the main sale to a broken add-on. */
        if (items.length === 1) {
          busy(false);
          warn((err && err.description) ? err.description : 'Sorry, that is unavailable right now.');
          return;
        }
        post([hero]).then(function () {
          busy(false);
          /* On the BUY NOW path we do NOT redirect here. Sending someone to
             checkout with an add-on silently missing is worse than making them
             read one line and press again. */
          warn('Added. One of the extras was unavailable and was left out.');
          openDrawer();
        })['catch'](function () {
          busy(false);
          warn('Something went wrong. Please try again.');
        });
      });
    }

    function checkoutUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root + 'checkout';
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); submitCart(false); });
    }
    if (stickyCta) {
      stickyCta.addEventListener('click', function (e) { e.preventDefault(); submitCart(false); });
    }
    var buyNow = root.querySelector('[data-mspdp-buynow]');
    if (buyNow) {
      buyNow.addEventListener('click', function (e) { e.preventDefault(); submitCart(true); });
    }

    /* ----- sticky bar reveal, IntersectionObserver only, no scroll handler
       The bar is shown whenever the inline CTA is OUT of view — in BOTH
       directions. The earlier version only revealed it once the CTA had
       scrolled ABOVE the viewport (boundingClientRect.top < 0), which left a
       dead zone from the fold down to the inline CTA at ~1,500px, i.e. exactly
       the band where most mobile sessions end. No buy control was visible
       there. Do not reintroduce the direction test. */
    if (sticky && inlineCta && typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function (entries) {
        var k;
        for (k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) { sticky.classList.remove('is-on'); }
          else { sticky.classList.add('is-on'); }
        }
      }, { threshold: 0 });
      io.observe(inlineCta);
    }

    /* ----- gallery dots, IntersectionObserver, no scroll handler --------- */
    var gal  = root.querySelector('[data-mspdp-gallery]');
    var dots = root.querySelector('[data-mspdp-dots]');
    if (gal && dots) {
      var slides = gal.querySelectorAll('.mspdp-slide');
      var dotEls = dots.querySelectorAll('.mspdp-dot');
      var mark = function (idx) {
        var k;
        for (k = 0; k < dotEls.length; k++) {
          dotEls[k].setAttribute('aria-current', k === idx ? 'true' : 'false');
        }
      };
      (function () {
        var k;
        for (k = 0; k < dotEls.length; k++) {
          (function (n) {
            dotEls[n].addEventListener('click', function () {
              if (slides[n]) { gal.scrollLeft = slides[n].offsetLeft - gal.offsetLeft; }
              mark(n);
            });
          }(k));
        }
      }());
      if (typeof IntersectionObserver !== 'undefined' && slides.length) {
        var gio = new IntersectionObserver(function (entries) {
          var best = null, k;
          for (k = 0; k < entries.length; k++) {
            if (!entries[k].isIntersecting) { continue; }
            if (!best || entries[k].intersectionRatio > best.intersectionRatio) { best = entries[k]; }
          }
          if (!best) { return; }
          var idx = -1, j;
          for (j = 0; j < slides.length; j++) { if (slides[j] === best.target) { idx = j; } }
          if (idx > -1) { mark(idx); }
        }, { root: gal, threshold: [0.5, 0.75, 1] });
        for (i = 0; i < slides.length; i++) { gio.observe(slides[i]); }
      }
      mark(0);
    }

    /* ----- thumb rail, arrows, zoom ------------------------------------- */
    var stage  = root.querySelector('[data-mspdp-gallery]');
    var thumbs = root.querySelector('[data-mspdp-thumbs]');

    function slideEls() { return stage ? stage.querySelectorAll('.mspdp-slide') : []; }

    function goTo(n) {
      var sl = slideEls();
      if (!sl.length) { return; }
      if (n < 0) { n = 0; }
      if (n > sl.length - 1) { n = sl.length - 1; }
      stage.scrollLeft = sl[n].offsetLeft - stage.offsetLeft;
      markAll(n);
    }

    function currentIndex() {
      var sl = slideEls(), k, best = 0, bestD = Infinity, d;
      for (k = 0; k < sl.length; k++) {
        d = Math.abs((sl[k].offsetLeft - stage.offsetLeft) - stage.scrollLeft);
        if (d < bestD) { bestD = d; best = k; }
      }
      return best;
    }

    function markAll(n) {
      var t = thumbs ? thumbs.querySelectorAll('.ms-thumb') : [], k;
      for (k = 0; k < t.length; k++) {
        t[k].setAttribute('aria-current', k === n ? 'true' : 'false');
      }
      /* keep the active thumb in view on the rail without moving the page */
      if (t[n] && thumbs) {
        var tr = t[n].getBoundingClientRect(), rr = thumbs.getBoundingClientRect();
        if (tr.top < rr.top || tr.bottom > rr.bottom ||
            tr.left < rr.left || tr.right > rr.right) {
          if (thumbs.scrollHeight > thumbs.clientHeight) {
            thumbs.scrollTop = t[n].offsetTop - thumbs.offsetTop;
          } else {
            thumbs.scrollLeft = t[n].offsetLeft - thumbs.offsetLeft;
          }
        }
      }
    }

    if (thumbs) {
      (function () {
        var t = thumbs.querySelectorAll('.ms-thumb'), k;
        for (k = 0; k < t.length; k++) {
          (function (n) {
            t[n].addEventListener('click', function () { goTo(n); });
          }(k));
        }
      }());
    }

    var prevBtn = root.querySelector('[data-mspdp-prev]');
    var nextBtn = root.querySelector('[data-mspdp-next]');
    if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); }); }
    if (nextBtn) { nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); }); }

    /* keep thumbs + dots honest when the visitor swipes instead of tapping */
    if (stage && typeof IntersectionObserver !== 'undefined') {
      var tio = new IntersectionObserver(function (entries) {
        var k, best = null;
        for (k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) { continue; }
          if (!best || entries[k].intersectionRatio > best.intersectionRatio) { best = entries[k]; }
        }
        if (!best) { return; }
        var sl = slideEls(), j;
        for (j = 0; j < sl.length; j++) { if (sl[j] === best.target) { markAll(j); } }
      }, { root: stage, threshold: [0.6] });
      var sl0 = slideEls();
      for (i = 0; i < sl0.length; i++) { tio.observe(sl0[i]); }
    }

    var zoomBtn = root.querySelector('[data-mspdp-zoom]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var sl = slideEls();
        var img = sl[currentIndex()] && sl[currentIndex()].querySelector('img');
        if (!img) { return; }
        var box = document.createElement('div');
        box.className = 'ms-lightbox is-on';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', 'Product image');
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'ms-lightbox-close';
        close.setAttribute('aria-label', 'Close');
        close.innerHTML = '&times;';
        var big = document.createElement('img');
        big.src = img.currentSrc || img.src;
        big.alt = img.alt || '';
        big.style.maxWidth = '100%';
        big.style.maxHeight = '100%';
        big.style.objectFit = 'contain';
        box.appendChild(big);
        box.appendChild(close);
        function shut() {
          if (box.parentNode) { box.parentNode.removeChild(box); }
          document.removeEventListener('keydown', onKey);
          zoomBtn.focus();
        }
        function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) { shut(); } }
        close.addEventListener('click', shut);
        box.addEventListener('click', function (e) { if (e.target === box) { shut(); } });
        document.addEventListener('keydown', onKey);
        document.body.appendChild(box);
        close.focus();
      });
    }

    /* ----- description tabs --------------------------------------------- */
    var tablist = root.querySelector('[data-mspdp-tablist]');
    if (tablist) {
      var tabs = tablist.querySelectorAll('.ms-tab');
      (function () {
        var k;
        for (k = 0; k < tabs.length; k++) {
          (function (n) {
            tabs[n].addEventListener('click', function () {
              var j, panel;
              for (j = 0; j < tabs.length; j++) {
                tabs[j].setAttribute('aria-selected', j === n ? 'true' : 'false');
                panel = document.getElementById(tabs[j].getAttribute('aria-controls'));
                if (panel) { panel.hidden = (j !== n); }
              }
            });
          }(k));
        }
      }());
    }

    /* ----- scroll reveal -------------------------------------------------
       The reference fades each feature panel's copy up as it enters. Styles
       live in ms-system.css (.ms-reveal / .is-in) and are gated behind .ms-js,
       so with JS off nothing is ever left invisible. */
    if (typeof IntersectionObserver !== 'undefined') {
      var reveals = root.querySelectorAll('.ms-panel-copy, .ms-stats, .ms-box, .ms-quote');
      (function () {
        var k;
        for (k = 0; k < reveals.length; k++) { reveals[k].classList.add('ms-reveal'); }
      }());
      var rioAlive = false;
      var rio = new IntersectionObserver(function (entries) {
        var k;
        rioAlive = true;
        for (k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            entries[k].target.classList.add('is-in');
            rio.unobserve(entries[k].target);
          }
        }
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
      for (i = 0; i < reveals.length; i++) { rio.observe(reveals[i]); }
      /* Fail-safe. The hidden state is only ever acceptable while an observer is
         alive to undo it. If the callback has not run at all after a moment
         (throttled/background tab, or an engine that skips it), drop the effect
         rather than leave copy permanently at opacity 0. */
      setTimeout(function () {
        var m;
        if (rioAlive) { return; }
        for (m = 0; m < reveals.length; m++) { reveals[m].classList.add('is-in'); }
      }, 1500);
    }

    /* ----- demo video: nothing is fetched until the visitor taps --------- */
    root.addEventListener('click', function (e) {
      var btn = e.target;
      while (btn && btn !== root && !(btn.className && String(btn.className).indexOf('mspdp-play') > -1)) {
        btn = btn.parentNode;
      }
      if (!btn || btn === root) { return; }
      var mount = btn.parentNode;
      if (!mount || mount.getAttribute('data-mounted') === '1') { return; }
      mount.setAttribute('data-mounted', '1');

      var vd = document.createElement('video');
      vd.setAttribute('playsinline', '');        /* REQUIRED on iOS or it goes fullscreen */
      vd.setAttribute('webkit-playsinline', ''); /* legacy WKWebView                      */
      vd.setAttribute('controls', '');
      vd.setAttribute('preload', 'auto');
      vd.setAttribute('aria-label', mount.getAttribute('data-video-label') || '');
      vd.muted = true;
      vd.src = mount.getAttribute('data-video-src');
      mount.appendChild(vd);
      btn.hidden = true;

      var p = vd.play();
      /* Autoplay is a REQUEST, not a guarantee: Low Power Mode blocks muted
         autoplay outright, and it is common on the phones of people watching
         Reels at the end of the day. */
      if (p && typeof p['catch'] === 'function') {
        p['catch'](function () { btn.hidden = false; });
      }
    });

    /* ----- bfcache restore: sticky + dots are scroll-derived ------------ */
    window.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) { return; }
      renderTotal();
      busy(false);
    });
  }

  for (var n = 0; n < roots.length; n++) {
    try { init(roots[n]); } catch (e) {}
  }
}());
